import { ConversionConstructedNoDates } from "@/types/types";

export const isHarmony = (
  conversion: ConversionConstructedNoDates
): boolean => {
  return conversion.conversionGroupId !== null;
};
